<template>
  <data-iterator
    :list="antecedents"
    add-new-text="Ajouter un antécédent"
    :live="liveListe"
    :icon="$getIcon('judiciaire')"
    :valids="valids"
    ref="dataIterator"
  >
    <template v-slot:show-mode="{ item }">
      <h3>{{ item.natureInfraction }}</h3>
      <p class="my-0">{{ item.dateEvenement ? item.dateEvenement.substring(0, 4) : "" }}</p>
    </template>
    <template v-slot:edit-mode="{ item }">
      <opq-text-field
        :code="'nature-infraction-' + codeInfraction"
        v-model="item.natureInfraction"
        :live="liveSasAntecedent(2203, item)"
      ></opq-text-field>
      <opq-date-picker
        :code="'date-infraction-' + codeInfraction"
        v-model="item.dateEvenement"
        :live="liveSasAntecedent(2207, item)"
      ></opq-date-picker>
      <opq-file :code="'document1-infraction-' + codeInfraction" :file="item.annexe1" optional :live="liveSasAntecedent(2204, item)"></opq-file>
      <opq-file :code="'document2-infraction-' + codeInfraction" :file="item.annexe2" optional :live="liveSasAntecedent(2205, item)"></opq-file>
    </template>
  </data-iterator>
</template>

<script>
export default {
  props: {
    antecedents: { type: Array },
    codeInfraction: { type: String, required: true },
    sasId: { type: String, required: true },
    valids: { type: Array, default: () => [] }
  },
  computed: {
    liveListe() {
      return {
        endpoint: "sas-antecedents-judiciaires",
        sasId: this.sasId,
        payload: { codeInfraction: this.codeInfraction }
      }
    }
  },

  methods: {
    liveSasAntecedent(cle, item) {
      return { endpoint: "sas-antecedents-judiciaires", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>